import React, {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {logPageLoadEvents, sendEvarData} from '@ibibo/analytics';
import {useHistory} from 'react-router-dom';
import OnboardingNew from '../../OnboardingNew';
import TextInput from '../TextInput/TextInput';
import AppButon from '../AppButon/AppButon';
import VerifyEmailGcc from '../../PopUp/VerifyEmailGcc/VerifyEmailGcc';
import OtpField from '../OtpField/OtpField';
import {
  submitGccMobileOtp,
  submitGccMobileOtpVerificationNumber,
} from '../../../../../store/actions/thunk';
import {
  tokenSelector,
  authTokenSelector,
  countryCodeSelector,
} from '../../../../../store/selectors';

import * as S from './MobileVerification.styles';

const MobileVerification = ({mobileNumber, responseRedirectUrl}) => {
  const dispatch = useDispatch();
  const token = useSelector(tokenSelector);
  const countryCode = useSelector(countryCodeSelector);
  const [mobile, setMobile] = useState('');
  //const [countryCode, setCountryCode] = useState('');
  const [showOtpScreen, setShowOtpScreen] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    logPageLoadEvents('onboarding:signup:landing', {
      eVar15: 'onboarding:mobileotpvalidation|mypartner',
      channel: 'onboarding|mypartner',
      prop24: 'onboarding|mypartner',
      eVar24: 'onboarding|mypartner',
      prop27: '/agent/login/',
      eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
    });
  }, []);

  useEffect(() => {
    setMobile(mobileNumber);
  }, [mobileNumber]);

  const handleSubmitMobileNumber = () => {
    //setShowOtpScreen(true);
    const data = {
      mobile,
      country_code: '971',
      token: token,
    };
    dispatch(
      submitGccMobileOtpVerificationNumber(
        data,
        successCallbackSubmitNumber,
        errorCallbackSubmitNumber,
      ),
    );
  };

  const successCallbackSubmitNumber = response => {
    setShowOtpScreen(true);
    setError(null);
  };

  const errorCallbackSubmitNumber = err => {
    logPageLoadEvents('onboarding:signup:landing', {
      eVar15: 'onboarding:mobileotpvalidation|mypartner',
      channel: 'onboarding|mypartner',
      prop24: 'onboarding|mypartner',
      eVar24: 'onboarding|mypartner',
      prop27: '/agent/login/',
      eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
      prop54: 'myPartner_onboarding_APIerror',
    });
    setError(err);
  };

  const handleChange = otp => {
    if (otp.length === 6) {
      logPageLoadEvents('onboarding:signup:landing', {
        eVar15: 'onboarding:mobileotpvalidation|mypartner',
        channel: 'onboarding|mypartner',
        prop24: 'onboarding|mypartner',
        eVar24: 'onboarding|mypartner',
        prop27: '/agent/login/',
        eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
        prop54: 'myPartner_onboarding_continue',
      });
  
      let fd = new FormData();
      fd.append('mobile_otp', otp);
      // fd.append('email_otp', data.email_otp);
      fd.append('mobile', mobile);
      fd.append('otp', otp);
      fd.append('country_code', '971');
      dispatch(submitGccMobileOtp(fd, successCallbackOtp, errorCallbackOtp));
    }
  };

  const successCallbackOtp = resp => {
    window.open(responseRedirectUrl, '_self');
  };

  const errorCallbackOtp = err => {
    setError(err);
  };

  return !showOtpScreen ? (
    <>
      <S.Heading>Verify Mobile Number</S.Heading>
      <S.EditNumberContainer>
        <TextInput
          labelText={'Mobile Number'}
          placeholder="Mobile Number"
          classes={'appendTop30'}
          mobileNumber={true}
          setterFunction={setMobile}
          name={'mobile'}
          component={'mobileNumber'}
          setterObj={mobile}
          showOnlyUaeNumber={false}
          countryCode={countryCode}
          //setCountryCode={setCountryCode}
          stringValue={mobile}
        />
        <S.SubmitButtonContainer>
          <AppButon
            buttonText={'Send Otp'}
            isDisabled={false}
            onPress={handleSubmitMobileNumber}
            isError={false}
            classes={''}
            butonWidth="20px"
          />
        </S.SubmitButtonContainer>
        {error?.message && <S.ErrorMsg>{error?.message}</S.ErrorMsg>}
      </S.EditNumberContainer>
    </>
  ) : (
    <S.Content>
      <S.Heading>Enter OTP</S.Heading>
      <OtpField
        labelText=""
        resendOtp="Resend OTP"
        editNumber="Edit Number"
        onChange={handleChange}
        setShowOtpScreen={setShowOtpScreen}
        resendOtpCaller={handleSubmitMobileNumber}
      />
      {error?.message && <S.ErrorMsg>{error?.message}</S.ErrorMsg>}
    </S.Content>
  );
};

export default MobileVerification;
